import { call, takeLatest, put } from "redux-saga/effects"
import {
  requestPermissions,
  requestPermissionsByRoleCode,
  requestUpsertPermission,
  requestDeletePermission,
} from "appRedux/sagas/requests/permissions"
import {
  getPermissions,
  getPermissionsSuccess,
  getPermissionsByRoleCode,
  getPermissionsByRoleCodeSuccess,
  upsertPermission,
  upsertPermissionSuccess,
  deletePermission,
  deletePermissionSuccess,
} from "appRedux/slices/permissions"
import { fetchError } from "appRedux/slices/common"
import toastr from "toastr"
import "toastr/build/toastr.min.css"

function* handleGetPermissions() {
  try {
    const data = yield call(requestPermissions)
    yield put(getPermissionsSuccess(data))
  } catch (error) {
    yield put(fetchError(error))
  }
}

function* handleGetPermissionsByRoleCode(payload) {
  try {
    const data = yield call(requestPermissionsByRoleCode, payload)
    yield put(getPermissionsByRoleCodeSuccess(data))
  } catch (error) {
    yield put(fetchError(error))
  }
}

function* handleUpsertPermissionGenerator({ payload }) {
  try {
    const data = yield call(requestUpsertPermission, payload)
    toastr.success("Action successfull!!")

    yield put(upsertPermissionSuccess(data.data))
  } catch (error) {
    toastr.error("Action Failed !!")
    yield put(fetchError(error))
  }
}

function* handleDeletePermissionGenerator({ payload }) {
  try {
    const data = yield call(requestDeletePermission, payload)
    toastr.success("Action successfull!!")

    yield put(deletePermissionSuccess(data.data))
  } catch (error) {
    toastr.error("Action Failed !!")
    yield put(fetchError(error))
  }
}

export default function* watcherSaga() {
  yield takeLatest(getPermissions.type, handleGetPermissions),
    yield takeLatest(
      getPermissionsByRoleCode.type,
      handleGetPermissionsByRoleCode
    ),
    yield takeLatest(upsertPermission.type, handleUpsertPermissionGenerator),
    yield takeLatest(deletePermission.type, handleDeletePermissionGenerator)
}
